import "./App.css";
import SignUpform from "./components/SignUpForm";

function App() {
  return (
    <div className="App">
      <SignUpform/>
    </div>
  );
}

export default App;
